import {CustomText, H6Text} from '@buncha/components/core/text';

import {Box} from '@buncha/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {ScanBarcodeHeaderStyle} from './Style';
import {Touchable} from '@buncha/components/core/touchable';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  unableToScanBottomSheetHandele: () => void;
}

const ScanBarcodeHeader = (props: Props) => {
  const theme = useColorThemeType();
  const {title, body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};

  return (
    <Box style={ScanBarcodeHeaderStyle.container}>
      <H6Text style={ScanBarcodeHeaderStyle.titleStyle}>
        {body?.scanAllBarcodes}
      </H6Text>
      <Touchable onPress={props?.unableToScanBottomSheetHandele}>
        <CustomText
          style={[
            ScanBarcodeHeaderStyle.unableToScanText,
            {
              color: theme?.text.red[100],
            },
          ]}>
          {title?.unableToScan}
        </CustomText>
      </Touchable>
    </Box>
  );
};

export default React.memo(ScanBarcodeHeader);
